import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import Viagem from "@/models/viagem";
import { ViagemAPI } from "@/api/viagem.api";

const viagemAPI = new ViagemAPI();

const create = (viagem: Viagem): AxiosObservable<Viagem> => {
  return viagemAPI.createViagem(viagem);
};

const getAllViagens = (
  autorizacaoFretamentoId: number
): AxiosObservable<any[]> => {
  return viagemAPI.getAllViagens(autorizacaoFretamentoId);
};
const removeViagem = (id: number): AxiosObservable<any> => {
  return viagemAPI.removeViagem(id);
};

export default {
  create,
  getAllViagens,
  removeViagem
};
